import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_08283616 from 'nuxt_plugin_plugin_08283616' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_4465b420 from 'nuxt_plugin_sentryserver_4465b420' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_7813b468 from 'nuxt_plugin_sentryclient_7813b468' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_vuewaitplugin_1ccf1d5e from 'nuxt_plugin_vuewaitplugin_1ccf1d5e' // Source: ./vue-wait-plugin.js (mode: 'all')
import nuxt_plugin_portalvue_233115a7 from 'nuxt_plugin_portalvue_233115a7' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_libpluginc102bb08_c9311210 from 'nuxt_plugin_libpluginc102bb08_c9311210' // Source: ./lib.plugin.c102bb08.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_d55bcc58 from 'nuxt_plugin_cookieuniversalnuxt_d55bcc58' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vuescrollto_772c2a5d from 'nuxt_plugin_vuescrollto_772c2a5d' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_pluginclient_8855f2dc from 'nuxt_plugin_pluginclient_8855f2dc' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_218e781a from 'nuxt_plugin_pluginserver_218e781a' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_axios_2e0a522c from 'nuxt_plugin_axios_2e0a522c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_env_6ad7cbd4 from 'nuxt_plugin_env_6ad7cbd4' // Source: ../plugins/env.ts (mode: 'all')
import nuxt_plugin_routerpushasync_8db83d14 from 'nuxt_plugin_routerpushasync_8db83d14' // Source: ../plugins/router-push-async.ts (mode: 'all')
import nuxt_plugin_plugin_40c3d82a from 'nuxt_plugin_plugin_40c3d82a' // Source: ../modules/server-storage/plugin.ts (mode: 'server')
import nuxt_plugin_api_7852046e from 'nuxt_plugin_api_7852046e' // Source: ../plugins/api.ts (mode: 'all')
import nuxt_plugin_router_79dc5c8e from 'nuxt_plugin_router_79dc5c8e' // Source: ../plugins/router.ts (mode: 'all')
import nuxt_plugin_pagesmetatitle_a1b1e9c4 from 'nuxt_plugin_pagesmetatitle_a1b1e9c4' // Source: ../plugins/pages-meta-title.ts (mode: 'all')
import nuxt_plugin_vuelidate_4be431c8 from 'nuxt_plugin_vuelidate_4be431c8' // Source: ../plugins/vuelidate.js (mode: 'all')
import nuxt_plugin_errors_f8fa1014 from 'nuxt_plugin_errors_f8fa1014' // Source: ../plugins/errors.js (mode: 'all')
import nuxt_plugin_vueselect_af0f7784 from 'nuxt_plugin_vueselect_af0f7784' // Source: ../plugins/vue-select.js (mode: 'all')
import nuxt_plugin_vuebus_44a72cd8 from 'nuxt_plugin_vuebus_44a72cd8' // Source: ../plugins/vue-bus.js (mode: 'all')
import nuxt_plugin_maska_0381c858 from 'nuxt_plugin_maska_0381c858' // Source: ../plugins/maska.js (mode: 'all')
import nuxt_plugin_datepicker_f86071f6 from 'nuxt_plugin_datepicker_f86071f6' // Source: ../plugins/datepicker.js (mode: 'client')
import nuxt_plugin_vueslidercomponent_c19e4b6e from 'nuxt_plugin_vueslidercomponent_c19e4b6e' // Source: ../plugins/vue-slider-component.js (mode: 'client')
import nuxt_plugin_scrollmagic_75f4d1f4 from 'nuxt_plugin_scrollmagic_75f4d1f4' // Source: ../plugins/scroll-magic.js (mode: 'client')
import nuxt_plugin_windowwidth_09394eae from 'nuxt_plugin_windowwidth_09394eae' // Source: ../plugins/window-width.ts (mode: 'all')
import nuxt_plugin_ymapPlugin_43baa32b from 'nuxt_plugin_ymapPlugin_43baa32b' // Source: ../plugins/ymapPlugin.js (mode: 'client')
import nuxt_plugin_plugin_edc8c7b8 from 'nuxt_plugin_plugin_edc8c7b8' // Source: ../service/sockets/update-orders/plugin.ts (mode: 'client')
import nuxt_plugin_nuxtclientinitnuxtclientinitplugin0a40d747_8791b60e from 'nuxt_plugin_nuxtclientinitnuxtclientinitplugin0a40d747_8791b60e' // Source: ./nuxt-client-init.nuxt-client-init-plugin.0a40d747.ts (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"eda1","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Служба доставки еды EDA1.RU. У нас вы можете заказать блюда японской, мексиканской, французской и ирландской кухни."},{"name":"facebook-domain-verification","content":"avxcbqennzv6tmbidb45xqay27w7wy"},{"name":"yandex-verification","content":"bea560b1722b9860"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fimages\u002Ffavicon\u002Fnew\u002Ffavicon-180x180.png"},{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Fimages\u002Ffavicon\u002Fnew\u002Ffavicon.svg"},{"rel":"icon","sizes":"16x16","type":"image\u002Fpng","href":"\u002Fimages\u002Ffavicon\u002Fnew\u002Ffavicon-16x16.png"},{"rel":"icon","sizes":"32x32","type":"image\u002Fpng","href":"\u002Fimages\u002Ffavicon\u002Fnew\u002Ffavicon-32x32.png"},{"rel":"icon","sizes":"48x48","type":"image\u002Fpng","href":"\u002Fimages\u002Ffavicon\u002Fnew\u002Ffavicon-48x48.png"},{"rel":"icon","sizes":"96x96","type":"image\u002Fpng","href":"\u002Fimages\u002Ffavicon\u002Fnew\u002Ffavicon-96x96.png"}],"script":[{"src":"https:\u002F\u002Faf.click.ru\u002Faf.js?id=16846","defer":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_08283616 === 'function') {
    await nuxt_plugin_plugin_08283616(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_4465b420 === 'function') {
    await nuxt_plugin_sentryserver_4465b420(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_7813b468 === 'function') {
    await nuxt_plugin_sentryclient_7813b468(app.context, inject)
  }

  if (typeof nuxt_plugin_vuewaitplugin_1ccf1d5e === 'function') {
    await nuxt_plugin_vuewaitplugin_1ccf1d5e(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_233115a7 === 'function') {
    await nuxt_plugin_portalvue_233115a7(app.context, inject)
  }

  if (typeof nuxt_plugin_libpluginc102bb08_c9311210 === 'function') {
    await nuxt_plugin_libpluginc102bb08_c9311210(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d55bcc58 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d55bcc58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_772c2a5d === 'function') {
    await nuxt_plugin_vuescrollto_772c2a5d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_8855f2dc === 'function') {
    await nuxt_plugin_pluginclient_8855f2dc(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_218e781a === 'function') {
    await nuxt_plugin_pluginserver_218e781a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2e0a522c === 'function') {
    await nuxt_plugin_axios_2e0a522c(app.context, inject)
  }

  if (typeof nuxt_plugin_env_6ad7cbd4 === 'function') {
    await nuxt_plugin_env_6ad7cbd4(app.context, inject)
  }

  if (typeof nuxt_plugin_routerpushasync_8db83d14 === 'function') {
    await nuxt_plugin_routerpushasync_8db83d14(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin_40c3d82a === 'function') {
    await nuxt_plugin_plugin_40c3d82a(app.context, inject)
  }

  if (typeof nuxt_plugin_api_7852046e === 'function') {
    await nuxt_plugin_api_7852046e(app.context, inject)
  }

  if (typeof nuxt_plugin_router_79dc5c8e === 'function') {
    await nuxt_plugin_router_79dc5c8e(app.context, inject)
  }

  if (typeof nuxt_plugin_pagesmetatitle_a1b1e9c4 === 'function') {
    await nuxt_plugin_pagesmetatitle_a1b1e9c4(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4be431c8 === 'function') {
    await nuxt_plugin_vuelidate_4be431c8(app.context, inject)
  }

  if (typeof nuxt_plugin_errors_f8fa1014 === 'function') {
    await nuxt_plugin_errors_f8fa1014(app.context, inject)
  }

  if (typeof nuxt_plugin_vueselect_af0f7784 === 'function') {
    await nuxt_plugin_vueselect_af0f7784(app.context, inject)
  }

  if (typeof nuxt_plugin_vuebus_44a72cd8 === 'function') {
    await nuxt_plugin_vuebus_44a72cd8(app.context, inject)
  }

  if (typeof nuxt_plugin_maska_0381c858 === 'function') {
    await nuxt_plugin_maska_0381c858(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datepicker_f86071f6 === 'function') {
    await nuxt_plugin_datepicker_f86071f6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueslidercomponent_c19e4b6e === 'function') {
    await nuxt_plugin_vueslidercomponent_c19e4b6e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrollmagic_75f4d1f4 === 'function') {
    await nuxt_plugin_scrollmagic_75f4d1f4(app.context, inject)
  }

  if (typeof nuxt_plugin_windowwidth_09394eae === 'function') {
    await nuxt_plugin_windowwidth_09394eae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ymapPlugin_43baa32b === 'function') {
    await nuxt_plugin_ymapPlugin_43baa32b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin_edc8c7b8 === 'function') {
    await nuxt_plugin_plugin_edc8c7b8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtclientinitnuxtclientinitplugin0a40d747_8791b60e === 'function') {
    await nuxt_plugin_nuxtclientinitnuxtclientinitplugin0a40d747_8791b60e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    router.push(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
